exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.example-drag label.btn {\r\n  margin-bottom: 0;\r\n  margin-right: 1rem;\n}\n.example-drag .drop-active {\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  left: 0;\r\n  position: fixed;\r\n  z-index: 9999;\r\n  opacity: 0.6;\r\n  text-align: center;\r\n  background: #000;\n}\n.example-drag .drop-active h3 {\r\n  margin: -0.5em 0 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  right: 0;\r\n  transform: translateY(-50%);\r\n  font-size: 40px;\r\n  color: #fff;\r\n  padding: 0;\n}\r\n", ""]);

// exports
